(() => {
  const observed = new WeakSet();
  const scan = () => document.querySelectorAll('.multicolumn-section').forEach(section => {
    if (observed.has(section)) return; observed.add(section);
    const slider = section.querySelector('.swiper--multicolumn'); if (!slider) return;
    const media = matchMedia('(max-width:575px)'); let swiper, near = false;
    const update = () => {
      if (!section.isConnected) {media.removeEventListener('change',update);swiper?.destroy(true,true);return;}
      if (media.matches && near && !swiper) {
        slider.classList.add('multicolumn-swiper-wrapper');
        section.querySelectorAll('.multicolumn-list__item').forEach(s=>s.classList.add('swiper-slide'));
        swiper = new Swiper(slider,{loop:false,slidesPerView:1,spaceBetween:0,navigation:{nextEl:section.querySelector('.multicolumn-button-next'),prevEl:section.querySelector('.multicolumn-button-prev')},breakpoints:{576:{slidesPerView:2}}});
      } else if (!media.matches && swiper) {
        swiper.destroy(true,true);swiper=null;slider.classList.remove('multicolumn-swiper-wrapper');
        section.querySelectorAll('.multicolumn-list__item').forEach(s=>s.classList.remove('swiper-slide'));
      }
    };
    media.addEventListener('change',update);
    if (!('IntersectionObserver' in window)) {near=true;update();return;}
    const observer = new IntersectionObserver(entries=>{
      if (!entries.some(e=>e.isIntersecting))return;observer.disconnect();near=true;update();
    },{rootMargin:'400px 0px'});observer.observe(section);
  });
  scan();document.addEventListener('shopify:section:load',scan);
})();
